/* eslint-disable max-len */
/* eslint-disable prettier/prettier */

/**
 * This file can be used for unit tests.
 */
import {
  CleanScreenResultType,
  PatientOverviewDto,
  RewardReasonType,
  SubstanceUsageType,
  TriggerDisplayType,
} from '@peartherapeutics/hylia-api-client';

export const overviewInitialState: PatientOverviewDto = {
  dailySummaries: [
    {
      averageCravingIntensity: 5,
      date: '2022-10-01T04:00:00.000Z',
      medicationUse: 'no-data' as SubstanceUsageType,
      substanceUse: 'no-use' as SubstanceUsageType,
      triggers: [
        {
          type: 'Hungry' as TriggerDisplayType,
          averageIntensity: 1,
        },
        {
          type: 'Lonely' as TriggerDisplayType,
          averageIntensity: 4.5,
        },
        {
          type: 'Social Pressure' as TriggerDisplayType,
          averageIntensity: 3,
        },
      ],
    },
    {
      averageCravingIntensity: 5,
      date: '2022-10-02T04:00:00.000Z',
      medicationUse: 'used' as SubstanceUsageType,
      substanceUse: 'no-use' as SubstanceUsageType,
      triggers: [
        {
          type: 'Hungry' as TriggerDisplayType,
          averageIntensity: 3,
        },
        {
          type: 'Lonely' as TriggerDisplayType,
          averageIntensity: 4.5,
        },
      ],
    },
    {
      averageCravingIntensity: 5,
      date: '2022-10-03T04:00:00.000Z',
      medicationUse: 'used' as SubstanceUsageType,
      substanceUse: 'no-use' as SubstanceUsageType,
      triggers: [
        {
          type: 'Hungry' as TriggerDisplayType,
          averageIntensity: 3,
        },
        {
          type: 'Lonely' as TriggerDisplayType,
          averageIntensity: 4,
        },
      ],
    },
    {
      date: '2022-10-04T04:00:00.000Z',
      medicationUse: 'no-data' as SubstanceUsageType,
      substanceUse: 'no-data' as SubstanceUsageType,
      triggers: [],
      averageCravingIntensity: 0,
    },
    {
      date: '2022-10-05T04:00:00.000Z',
      medicationUse: 'used' as SubstanceUsageType,
      substanceUse: 'no-data' as SubstanceUsageType,
      triggers: [],
      averageCravingIntensity: 0,
    },
    {
      averageCravingIntensity: 2,
      date: '2022-10-06T04:00:00.000Z',
      medicationUse: 'used' as SubstanceUsageType,
      substanceUse: 'no-use' as SubstanceUsageType,
      triggers: [
        {
          type: 'Lonely' as TriggerDisplayType,
          averageIntensity: 1,
        },
      ],
    },
    {
      averageCravingIntensity: 4,
      date: '2022-10-07T04:00:00.000Z',
      medicationUse: 'used' as SubstanceUsageType,
      substanceUse: 'no-use' as SubstanceUsageType,
      triggers: [
        {
          type: 'Hungry' as TriggerDisplayType,
          averageIntensity: 5,
        },
        {
          type: 'Lonely' as TriggerDisplayType,
          averageIntensity: 2,
        },
      ],
    },
    {
      date: '2022-10-08T04:00:00.000Z',
      medicationUse: 'no-use' as SubstanceUsageType,
      substanceUse: 'used' as SubstanceUsageType,
      triggers: [],
      averageCravingIntensity: 0,
    },
    {
      averageCravingIntensity: 6,
      date: '2022-10-09T04:00:00.000Z',
      medicationUse: 'used' as SubstanceUsageType,
      substanceUse: 'used' as SubstanceUsageType,
      triggers: [
        {
          type: 'Lonely' as TriggerDisplayType,
          averageIntensity: 4,
        },
        {
          type: 'Social Pressure' as TriggerDisplayType,
          averageIntensity: 4,
        },
      ],
    },
    {
      averageCravingIntensity: 5,
      date: '2022-10-10T04:00:00.000Z',
      medicationUse: 'no-data' as SubstanceUsageType,
      substanceUse: 'no-use' as SubstanceUsageType,
      triggers: [
        {
          type: 'Lonely' as TriggerDisplayType,
          averageIntensity: 3,
        },
        {
          type: 'Social Pressure' as TriggerDisplayType,
          averageIntensity: 4,
        },
      ],
    },
    {
      date: '2022-10-11T04:00:00.000Z',
      medicationUse: 'no-data' as SubstanceUsageType,
      substanceUse: 'no-data' as SubstanceUsageType,
      triggers: [],
      averageCravingIntensity: 0,
    },
    {
      date: '2022-10-12T04:00:00.000Z',
      medicationUse: 'no-data' as SubstanceUsageType,
      substanceUse: 'no-data' as SubstanceUsageType,
      triggers: [],
      averageCravingIntensity: 0,
    },
    {
      averageCravingIntensity: 6,
      date: '2022-10-13T04:00:00.000Z',
      medicationUse: 'no-data' as SubstanceUsageType,
      substanceUse: 'used' as SubstanceUsageType,
      triggers: [
        {
          type: 'Hungry' as TriggerDisplayType,
          averageIntensity: 3,
        },
        {
          type: 'Lonely' as TriggerDisplayType,
          averageIntensity: 4,
        },
      ],
    },
    {
      date: '2022-10-14T04:00:00.000Z',
      medicationUse: 'no-data' as SubstanceUsageType,
      substanceUse: 'no-data' as SubstanceUsageType,
      triggers: [],
      averageCravingIntensity: 0,
    },
    {
      date: '2022-10-15T04:00:00.000Z',
      medicationUse: 'no-data' as SubstanceUsageType,
      substanceUse: 'no-data' as SubstanceUsageType,
      triggers: [],
      averageCravingIntensity: 0,
    },
    {
      date: '2022-10-16T04:00:00.000Z',
      medicationUse: 'no-data' as SubstanceUsageType,
      substanceUse: 'no-data' as SubstanceUsageType,
      triggers: [],
      averageCravingIntensity: 0,
    },
    {
      averageCravingIntensity: 4,
      date: '2022-10-17T04:00:00.000Z',
      medicationUse: 'no-data' as SubstanceUsageType,
      substanceUse: 'no-use' as SubstanceUsageType,
      triggers: [
        {
          type: 'Hungry' as TriggerDisplayType,
          averageIntensity: 1,
        },
        {
          type: 'Lonely' as TriggerDisplayType,
          averageIntensity: 5,
        },
      ],
    },
    {
      averageCravingIntensity: 4,
      date: '2022-10-18T04:00:00.000Z',
      medicationUse: 'no-data' as SubstanceUsageType,
      substanceUse: 'no-use' as SubstanceUsageType,
      triggers: [
        {
          type: 'Hungry' as TriggerDisplayType,
          averageIntensity: 1,
        },
        {
          type: 'Lonely' as TriggerDisplayType,
          averageIntensity: 5,
        },
      ],
    },
    {
      date: '2022-10-19T04:00:00.000Z',
      medicationUse: 'no-data' as SubstanceUsageType,
      substanceUse: 'no-data' as SubstanceUsageType,
      triggers: [],
      averageCravingIntensity: 0,
    },
    {
      date: '2022-10-20T04:00:00.000Z',
      medicationUse: 'no-data' as SubstanceUsageType,
      substanceUse: 'no-data' as SubstanceUsageType,
      triggers: [],
      averageCravingIntensity: 0,
    },
    {
      date: '2022-10-21T04:00:00.000Z',
      medicationUse: 'used' as SubstanceUsageType,
      substanceUse: 'no-data' as SubstanceUsageType,
      triggers: [],
      averageCravingIntensity: 0,
    },
    {
      averageCravingIntensity: 2,
      date: '2022-10-22T04:00:00.000Z',
      medicationUse: 'used' as SubstanceUsageType,
      substanceUse: 'no-use' as SubstanceUsageType,
      triggers: [
        {
          type: 'Lonely' as TriggerDisplayType,
          averageIntensity: 1,
        },
      ],
    },
    {
      averageCravingIntensity: 4,
      date: '2022-10-23T04:00:00.000Z',
      medicationUse: 'no-data' as SubstanceUsageType,
      substanceUse: 'no-use' as SubstanceUsageType,
      triggers: [
        {
          type: 'Hungry' as TriggerDisplayType,
          averageIntensity: 5,
        },
        {
          type: 'Lonely' as TriggerDisplayType,
          averageIntensity: 2,
        },
      ],
    },
    {
      date: '2022-10-24T04:00:00.000Z',
      medicationUse: 'no-use' as SubstanceUsageType,
      substanceUse: 'used' as SubstanceUsageType,
      triggers: [],
      averageCravingIntensity: 0,
    },
    {
      date: '2022-10-25T04:00:00.000Z',
      medicationUse: 'no-data' as SubstanceUsageType,
      substanceUse: 'no-data' as SubstanceUsageType,
      triggers: [],
      averageCravingIntensity: 0,
    },
    {
      date: '2022-10-26T04:00:00.000Z',
      medicationUse: 'no-data' as SubstanceUsageType,
      substanceUse: 'no-data' as SubstanceUsageType,
      triggers: [],
      averageCravingIntensity: 0,
    },
    {
      date: '2022-10-27T04:00:00.000Z',
      medicationUse: 'no-data' as SubstanceUsageType,
      substanceUse: 'no-data' as SubstanceUsageType,
      triggers: [],
      averageCravingIntensity: 0,
    },
    {
      date: '2022-10-28T04:00:00.000Z',
      medicationUse: 'no-data' as SubstanceUsageType,
      substanceUse: 'no-data' as SubstanceUsageType,
      triggers: [],
      averageCravingIntensity: 0,
    },
    {
      date: '2022-10-29T04:00:00.000Z',
      medicationUse: 'no-data' as SubstanceUsageType,
      substanceUse: 'no-data' as SubstanceUsageType,
      triggers: [],
      averageCravingIntensity: 0,
    },
    {
      date: '2022-10-30T04:00:00.000Z',
      medicationUse: 'no-data' as SubstanceUsageType,
      substanceUse: 'no-data' as SubstanceUsageType,
      triggers: [],
      averageCravingIntensity: 0,
    },
    {
      date: '2022-10-31T04:00:00.000Z',
      medicationUse: 'no-data' as SubstanceUsageType,
      substanceUse: 'no-data' as SubstanceUsageType,
      triggers: [],
      averageCravingIntensity: 0,
    },
  ],
  startDate: '2022-10-01T04:00:00.000Z',
  endDate: '2022-11-01T19:12:11.167Z',
  minDate: '2022-07-20T04:00:00.000Z',
  maxDate: '2022-11-01T04:00:00.000Z',
  dateRange: '10/1/2022 - 11/1/2022',
  lessonCompletionCount: 19,
  lessonsCompleted: [
    {
      id: 'what-is-a-functional-analysis',
      name: 'What is a Functional Analysis?',
      lastCompletionDate: '2022-10-24T06:00:00.000Z',
    },
    {
      id: 'conducting-a-functional-analysis',
      name: 'Conducting a Functional Analysis',
      lastCompletionDate: '2022-10-24T07:00:00.000Z',
    },
    {
      id: 'self-management-planning',
      name: 'Self-Management Planning',
      lastCompletionDate: '2022-10-24T02:00:00.000Z',
    },
    {
      id: 'introduction-to-problem-solving',
      name: 'Introduction to Problem Solving',
      lastCompletionDate: '2022-10-24T02:00:00.000Z',
    },
    {
      id: 'effective-problem-solving',
      name: 'Effective Problem Solving',
      worksheetPath:
        'http://localhost:10825/clinical-content/en/effective-problem-solving/worksheets/effective-problem-solving.pdf',
      lastCompletionDate: '2022-10-24T02:00:00.000Z',
    },
    {
      id: 'drug-refusal-skills-training',
      name: 'Drug Refusal Skills Training',
      lastCompletionDate: '2022-10-24T02:00:00.000Z',
    },
    {
      id: 'introduction-to-relaxation-training',
      name: 'Introduction to Relaxation Training',
      lastCompletionDate: '2022-10-04T08:23:00.000Z',
    },
    {
      id: 'progressive-muscle-relaxation-training',
      name: 'Progressive Muscle Relaxation Training',
      worksheetPath:
        'http://localhost:10825/clinical-content/en/progressive-muscle-relaxation-training/worksheets/progressive-muscle-relaxation-training.pdf',
      lastCompletionDate: '2022-10-04T08:23:00.000Z',
    },
    {
      id: 'progressive-muscle-relaxation-generalization-training',
      name: 'Progressive Muscle Relaxation Generalization Training',
      worksheetPath:
        'http://localhost:10825/clinical-content/en/progressive-muscle-relaxation-generalization-training/worksheets/progressive-muscle-relaxation-generalization-training.pdf',
      lastCompletionDate: '2022-10-04T08:23:00.000Z',
    },
    {
      id: 'introduction-to-anger-management',
      name: 'Introduction to Anger Management',
      lastCompletionDate: '2022-10-04T08:23:00.000Z',
    },
    {
      id: 'how-to-become-more-aware-of-the-feeling-of-anger',
      name: 'How to Become More Aware of the Feeling of Anger',
      worksheetPath:
        'http://localhost:10825/clinical-content/en/how-to-become-more-aware-of-the-feeling-of-anger/worksheets/how-to-become-more-aware-of-the-feeling-of-anger.pdf',
      lastCompletionDate: '2022-10-10T08:23:00.000Z',
    },
    {
      id: 'coping-with-anger',
      name: 'Coping with Anger',
      worksheetPath:
        'http://localhost:10825/clinical-content/en/coping-with-anger/worksheets/coping-with-anger.pdf',
      lastCompletionDate: '2022-10-10T08:23:00.000Z',
    },
    {
      id: 'relationship-counseling-part-1',
      name: 'Relationship Counseling Part 1',
      lastCompletionDate: '2022-10-10T08:23:00.000Z',
    },
    {
      id: 'relationship-counseling-part-2',
      name: 'Relationship Counseling Part 2',
      lastCompletionDate: '2022-10-10T08:23:00.000Z',
    },
    {
      id: 'relationship-counseling-part-3',
      name: 'Relationship Counseling Part 3',
      lastCompletionDate: '2022-10-10T08:23:00.000Z',
    },
    {
      id: 'hepatitis',
      name: 'Hepatitis',
      lastCompletionDate: '2022-10-10T08:23:00.000Z',
    },
    {
      id: 'alcohol-use-and-risk-for-hiv-stis-and-hepatitis',
      name: 'Alcohol Use and Risk for HIV, STIs and Hepatitis',
      lastCompletionDate: '2022-10-17T08:23:00.000Z',
    },
    {
      id: 'getting-tested-for-hiv-stis-and-hepatitis',
      name: 'Getting Tested for HIV, STIs, and Hepatitis',
      lastCompletionDate: '2022-10-17T08:23:00.000Z',
    },
    {
      id: 'finding-more-hiv-sti-and-hepatitis-information',
      name: 'Finding More HIV, STI and Hepatitis Information',
      lastCompletionDate: '2022-10-17T08:23:00.000Z',
    },
  ],
  lessonsToDo: [
    {
      id: 'the-female-condom',
      name: 'The Female Condom',
    },
    {
      id: 'negotiating-safer-sex',
      name: 'Negotiating Safer Sex',
    },
    {
      id: 'taking-responsibility-for-choices',
      name: 'Taking Responsibility for Choices',
    },
    {
      id: 'birth-control-and-hiv-and-stis',
      name: 'Birth Control and HIV and STIs',
    },
    {
      id: 'living-with-hiv-communication-skills-for-disclosing-hiv-status',
      name: 'Living with HIV: Communication Skills for Disclosing HIV Status',
    },
    {
      id: 'living-with-hiv-drug-use-and-the-immune-system',
      name: 'Living with HIV: Drug Use and the Immune System',
    },
    {
      id: 'living-with-hiv-managing-treatment-and-medications',
      name: 'Living with HIV: Managing Treatment and Medications',
    },
    {
      id: 'living-with-hiv-implementing-daily-routines-to-promote-health',
      name: 'Living with HIV: Implementing Daily Routines to Promote Health',
    },
    {
      id: 'living-with-hepatitis-c-coping-skills',
      name: 'Living with Hepatitis C: Coping Skills',
    },
    {
      id: 'living-with-hepatitis-c-managing-treatment-and-promoting-health',
      name: 'Living with Hepatitis C: Managing Treatment and Promoting Health',
    },
    {
      id: 'naltrexone',
      name: 'Naltrexone',
    },
    {
      id: 'limited-alcohol-use',
      name: 'Limited Alcohol Use',
      worksheetPath:
        'http://localhost:10825/clinical-content/en/limited-alcohol-use/worksheets/limited-alcohol-use.pdf',
    },
    {
      id: 'alcohol-use-and-disulfiram-treatment',
      name: 'Alcohol Use and Disulfiram Treatment',
    },
  ],
  earnedRewards: [
    {
      amount: '$50',
      amountValue: 50,
      date: '2022-10-07T04:00:00.000Z',
      type: RewardReasonType.UserGuideCompletion,
    },
    {
      amount: '$20',
      amountValue: 20,
      date: '2022-10-04T04:00:00.000Z',
      type: RewardReasonType.NegativeScreen,
    },
    {
      amount: '$10',
      amountValue: 10,
      date: '2022-10-01T04:00:00.000Z',
      type: RewardReasonType.LessonCompletion,
    },
    {
      amount: '$5',
      amountValue: 5,
      date: '2022-09-28T04:00:00.000Z',
      type: RewardReasonType.UserGuideCompletion,
    },
    {
      amount: '$4',
      amountValue: 4,
      date: '2022-09-25T04:00:00.000Z',
      type: RewardReasonType.NegativeScreen,
    },
    {
      amount: '$3',
      amountValue: 3,
      date: '2022-09-22T04:00:00.000Z',
      type: RewardReasonType.LessonCompletion,
    },
    {
      amount: '$2',
      amountValue: 2,
      date: '2022-09-19T04:00:00.000Z',
      type: RewardReasonType.UserGuideCompletion,
    },
    {
      amount: '$1',
      amountValue: 1,
      date: '2022-09-15T04:00:00.000Z',
      type: RewardReasonType.NegativeScreen,
    },
    {
      amount: '$0',
      amountValue: 0,
      date: '2022-09-12T04:00:00.000Z',
      type: RewardReasonType.LessonCompletion,
    },
  ],
  substanceUseDaysCount: 4,
  sumEarnedRewards: '$95',
  urineDrugScreens: [
    {
      date: '2022-10-03T04:00:00.000Z',
      result: 'Negative' as CleanScreenResultType,
    },
    {
      date: '2022-10-04T04:00:00.000Z',
      result: 'Negative' as CleanScreenResultType,
    },
    {
      date: '2022-10-07T04:00:00.000Z',
      result: 'Negative' as CleanScreenResultType,
    },
    {
      date: '2022-10-11T04:00:00.000Z',
      result: 'Negative' as CleanScreenResultType,
    },
    {
      date: '2022-10-12T04:00:00.000Z',
      result: 'Positive' as CleanScreenResultType,
    },
    {
      date: '2022-10-13T04:00:00.000Z',
      result: 'Negative' as CleanScreenResultType,
    },
    {
      date: '2022-10-14T04:00:00.000Z',
      result: 'Positive' as CleanScreenResultType,
    },
    {
      date: '2022-10-19T04:00:00.000Z',
      result: 'Negative' as CleanScreenResultType,
    },
    {
      date: '2022-10-20T04:00:00.000Z',
      result: 'Negative' as CleanScreenResultType,
    },
  ],
  showBupUse: false,
  inAppCm: true,
};
